import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import "src/modules/i18n"
import "./index.css"
import "./styles/common.scss"
import "./styles/globals.css"
import { initDatadog } from "./lib/datadog"

// Datadog RUM の初期化(env 未設定なら no-op)。React 描画前に実行する。
initDatadog()

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
